import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import MainPage from "./MainPage";
import SecondPage from "./SecondPage";

import {
  BrowserRouter,
  Routes,
  Route,
  Switch,
  useLocation,
} from "react-router-dom";
import Layout from "./Layout";
import Roadmap from "./Roadmap";
import Merch from "./Merch";
import Traits from "./Traits";
import Nip from "./Nip";
import Team from "./Team";
import Bodega from "./Bodega";
import Legal from "./Legal";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<MainPage />} />
          <Route path="bodega" element={<Bodega />} />
          <Route path="roadmap" element={<Roadmap />} />
          <Route path="merch" element={<Merch />} />
          <Route path="traits" element={<Traits />} />
          <Route path="nip" element={<Nip />} />
          <Route path="team" element={<Team />} />
          <Route path="legal" element={<Legal />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
